import React, { useEffect } from 'react'
import TabComponent from '../../component/TabComponent'
import AgentList from './agentList'
import CustomerList from './customerList'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

export default function Agent() {
  const { profile } = useSelector(state => state.profile)
  const location = useLocation()
  const navigate = useNavigate()
  const dataTabs = [
    {
      title: 'รายการลูกค้า',
      page: <CustomerList/>,
      url: '/agent/customer-list',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Customer.Read')?.Permit

    },
    {
      title: 'รายการตัวแทนจำหน่าย',
      page: <AgentList/>,
      url:'/agent/agent-list',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Agent.Read')?.Permit
    },
  ]
  useEffect(() => {
    if (location.pathname === '/agent') {
        navigate(dataTabs[0].url)
    }
}, [location.pathname])
  return (
    <div style={{ padding: '10px 30px' }}>
      <TabComponent dataTabs={dataTabs} />
    </div>
  )
}
